import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  SUBMIT_LOYALITY_CANCEL_SERVICE_FULFILLED,
  SUBMIT_LOYALITY_CANCEL_SERVICE_PENDING,
  SUBMIT_LOYALITY_CANCEL_SERVICE_FAILED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"

export const pendingAC = () => ({
  type: SUBMIT_LOYALITY_CANCEL_SERVICE_PENDING,
})

export const failedAC = () => ({
  type: SUBMIT_LOYALITY_CANCEL_SERVICE_FAILED,
})

export const fulfilledAC = (data) => ({
  type: SUBMIT_LOYALITY_CANCEL_SERVICE_FULFILLED,
  payload: data,
})

/**
 * @param {Object} params - The parameters for the missed pickup request.
 * @param {string} params.customerId - The ID of the customer.
 * @param {Object} params.payload - The payload data for the request.
 * @returns {Function} A thunk function that dispatches actions based on the API response.
 */

export const submitLoyalityCancelService =
  ({ customerId, payload }) =>
  (dispatch, getState) => {
    const api = `LOYALITY_CANCEL_SERVICE_SUBMIT`
    const template = URITemplate(urls.url[api])
    const state = getState()

    const url = template.expand({
      userId: get(state, `userAccount.userDetails.userId`, ``),
      customerId,
      lang: get(state, `siteLanguage.language`, ``),
    })
    const data = {
      ...payload,
    }

    const config = {
      method: `POST`,
      headers: {},
      data,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      return submitLoyalityCancelServiceHelper(url, config, dispatch, data)
    })
  }

export const submitLoyalityCancelServiceHelper = (
  url,
  config,
  dispatch,
  data,
) => {
  dispatch(pendingAC())
  return axios
    .create(config)
    .post(url, data)
    .then((response) => {
      const data = get(response, "data", {})
      const payload = {
        data: get(data, "data", {}),
        errorMsg: get(data, "errorMsg", ""),
        requestTrackingId: get(data, "requestTrackingId", ""),
        status: get(data, "status", ""),
        statusCode: get(data, "statusCode", ""),
      }
      dispatch(fulfilledAC(payload))
      return payload
    })
    .catch(() => {
      dispatch(failedAC())
    })
}
